module.exports = __webpack_public_path__ + "assets/step-2-ab0d8927db339126502cf19cb754c62a.png";